/**
 * The client portal's tabs (W5, DUP-4). There is one portal:
 * `/ClientDashboard`, its tab in `?tab=` (useTabParam), so a tab can be
 * linked and bookmarked. The five former stand-alone pages (ClientCalls,
 * ClientMeetings, ClientPerformance, ClientSettings, ClientHelp) are gone;
 * their routes redirect to the matching tab (DUP-7), see App.tsx.
 * Doc: DESIGN.md §5 « viewer (client portal) ».
 */
export const PORTAL_PATH = '/ClientDashboard';

export const PORTAL_TABS = ['home', 'performance', 'calls', 'prospects', 'meetings', 'settings', 'help'] as const;
export type PortalTab = (typeof PORTAL_TABS)[number];

/** Former stand-alone page → the tab that replaces it. */
export const PORTAL_REDIRECTS: ReadonlyArray<readonly [string, PortalTab]> = [
  ['ClientCalls', 'calls'],
  ['ClientMeetings', 'meetings'],
  ['ClientPerformance', 'performance'],
  ['ClientSettings', 'settings'],
  ['ClientHelp', 'help'],
];

export function portalTabUrl(tab: PortalTab): string {
  return tab === 'home' ? PORTAL_PATH : `${PORTAL_PATH}?tab=${tab}`;
}
